module.exports = __webpack_public_path__ + "img/logo.21158d76.png";